'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _events = require('events');

var _util = require('../util.js');

var _util2 = _interopRequireDefault(_util);

var _pack = require('../ipos/pack');

var _pack2 = _interopRequireDefault(_pack);

var _pack3 = require('../mobile/pack');

var _pack4 = _interopRequireDefault(_pack3);

var _pack5 = require('../points/pack');

var _pack6 = _interopRequireDefault(_pack5);

var _label = require('../ipos/label');

var _label2 = _interopRequireDefault(_label);

var _label3 = require('../mobile/label');

var _label4 = _interopRequireDefault(_label3);

var _label5 = require('../points/label');

var _label6 = _interopRequireDefault(_label5);

var _addible = require('../ipos/addible');

var _addible2 = _interopRequireDefault(_addible);

var _addible3 = require('../mobile/addible');

var _addible4 = _interopRequireDefault(_addible3);

var _addible5 = require('../points/addible');

var _addible6 = _interopRequireDefault(_addible5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var create = _util2.default.create,
    emit = _util2.default.emit,
    deleteInstance = _util2.default.deleteInstance;

var invalidPacksMap = {};

var Group = function (_EventEmitter) {
  (0, _inherits3.default)(Group, _EventEmitter);

  function Group(data) {
    (0, _classCallCheck3.default)(this, Group);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Group.__proto__ || (0, _getPrototypeOf2.default)(Group)).call(this));

    _this.data = data;
    _this.setDefault();
    _this.setInvalidMap();
    _this.setPacksModel();
    _this.setLabelModel();
    _this.setAddibleModel();
    _this.setAllChecked();
    return _this;
  }

  (0, _createClass3.default)(Group, [{
    key: 'setInvalidMap',
    value: function setInvalidMap() {
      this.data.packs.forEach(function (pack) {
        if (pack.invalid) {
          invalidPacksMap[pack.id] = pack.invalid;
        }
      });
    }
  }, {
    key: 'getLabelModel',
    value: function getLabelModel() {
      var Model = {
        'ipos': _label2.default,
        'mobile': _label4.default,
        'points': _label6.default
      };
      return Model[_util2.default.getClient()];
    }
  }, {
    key: 'setAllChecked',
    value: function setAllChecked() {
      if (!this.data.editMode) {
        var checkedPacks = this.data.packs.filter(function (pack) {
          return pack.p_checked;
        });
        var invalidPacks = this.data.packs.filter(function (pack) {
          return pack.invalid && pack.invalid.invalid;
        });
        if (invalidPacks.length === this.data.packs.length) {
          this.data.disableCheck = true;
        } else {
          this.data.allChecked = checkedPacks.length + invalidPacks.length === this.data.packs.length;
          this.data.disableCheck = false;
        }
      }
    }
  }, {
    key: 'setAddibleModel',
    value: function setAddibleModel() {
      var _this2 = this;

      var AddibleMap = {
        'ipos': _addible2.default,
        'mobile': _addible4.default,
        'points': _addible6.default
      };
      var Addible = AddibleMap[_util2.default.getClient()];
      this.addibles = [];
      this.data.addiblePacks.forEach(function (a) {
        var addible = create(Addible, a);
        addible.on('complete', function () {
          _this2.refreshPreview(true);
        });
        _this2.addibles.push(addible);
      });
    }
  }, {
    key: 'setLabelModel',
    value: function setLabelModel() {
      var _this3 = this;

      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      var Label = this.getLabelModel();
      this.labels = [];

      this.data.labels.forEach(function (l) {
        var label = create(Label, l, 'LABEL');
        _this3.labels.push(label);
      });
      this.data.giftPacks.forEach(function (l) {
        var label = create(Label, l, 'GIFT');
        if (_util2.default.getClient() == 'ipos') {
          label.on('refresh-preview', function () {
            _this3.refreshPreview();
          });
        }
        _this3.labels.push(label);
      });
    }
  }, {
    key: 'setPacksModel',
    value: function setPacksModel() {
      var _this4 = this;

      this.packs = [];
      this.data.packs.forEach(function (p) {
        var pack = _this4.setPackModel(p);
        _this4.packs.push(pack);
      });
    }
  }, {
    key: 'setPackModel',
    value: function setPackModel(p) {
      var _this5 = this;

      var PackMap = {
        'ipos': _pack2.default,
        'mobile': _pack4.default,
        'points': _pack6.default
      };
      var Pack = PackMap[_util2.default.getClient()];
      var pack = create(Pack, p);
      pack.on('select-change', function () {
        _this5.packSelectChange();
      });
      if (_util2.default.getClient() === 'ipos') {
        pack.on('refresh-preview', function () {
          _this5.refreshAllPreview(false, pack);
        });
      }
      return pack;
    }
  }, {
    key: 'setDefault',
    value: function setDefault() {
      this.data.disableCheck = false;
      this.data.allChecked = false;
      this.data.editMode = false;
      this.resetDefault(this.data);
    }
  }, {
    key: 'resetDefault',
    value: function resetDefault(data) {
      !data.packs && (data.packs = []);
      !data.labels && (data.labels = []);
      !data.giftPacks && (data.giftPacks = []);
      !data.addiblePacks && (data.addiblePacks = []);
    }
  }, {
    key: 'unselectAll',
    value: function unselectAll() {
      this.data.packs.forEach(function (pack) {
        pack.p_checked = false;
      });
    }
  }, {
    key: 'selectAll',
    value: function selectAll() {
      this.selectAllPacks();
      this.data.allChecked = true;
      return this;
    }
  }, {
    key: 'selectAllPacks',
    value: function selectAllPacks() {
      this.data.packs.forEach(function (pack) {
        pack.p_checked = true;
      });
      return this;
    }
  }, {
    key: 'packSelectChange',
    value: function packSelectChange() {
      if (!this.data.editMode) {
        var checkedPacks = this.data.packs.filter(function (pack) {
          return pack.p_checked;
        });
        var invalidPacks = this.data.packs.filter(function (pack) {
          return pack.invalid && pack.invalid.invalid;
        });
        this.data.allChecked = checkedPacks.length + invalidPacks.length === this.data.packs.length;
        this.refreshPreview();
      }
      this.emit('select-change');
    }
  }, {
    key: 'getPreviewPacks',
    value: function getPreviewPacks() {
      return this.data.packs.filter(function (pack) {
        return pack.p_checked || pack.benefit && pack.benefit.id;
      });
    }
  }, {
    key: 'refreshPreview',
    value: function refreshPreview(notRefreshAddible) {
      var _this6 = this;

      var previewPacks = this.getPreviewPacks();
      var checkedPacks = this.getCheckedPacks();

      if (!checkedPacks.length) {
        this.previewAtom = {}; // make preview ajax response invalid
        this.emptyPreview();
        this.data.allChecked = false;
        console.log(this.data.title, 'empty preview');
        this.emit('refresh-preview', null);
        return _promise2.default.resolve(null);
      }

      var atom = this.previewAtom = {};
      emit('show-loading', 'preview');
      return this.getPreview(previewPacks).then(function (_ref) {
        var data = _ref.data;

        if (atom !== _this6.previewAtom || _this6.data.editMode) {
          return _promise2.default.resolve(null);
        }
        emit('hide-loading', 'preview');
        _this6.resetDefault(data);
        if (!notRefreshAddible) {
          _this6.data.addiblePacks = data.addiblePacks;
          _this6.setAddibleModel();
        }
        _this6.data.labels = data.labels;
        _this6.data.giftPacks = data.giftPacks;

        if (data.packs.length) {
          _this6.data.packs.forEach(function (pack) {
            var pid = pack.id;
            data.packs.forEach(function (dpack) {
              if (pid === dpack.id) {
                pack.spv = dpack.spv;
              }
            });
          });
        }

        _this6.setLabelModel();
        _this6.setInvalidPacks(data);
        _this6.emit('refresh-preview', data);
        return { data: data };
      }).catch(function (_ref2) {
        var message = _ref2.message;

        emit('hide-loading', 'preview');
        emit('error', {
          message: message,
          type: 'preview'
        });
        return _promise2.default.reject();
      });
    }
  }, {
    key: 'setInvalidPacks',
    value: function setInvalidPacks(data) {
      var _this7 = this;

      !data.packs && (data.packs = []);
      data.packs.forEach(function (pack) {
        _this7.data.packs.some(function (p) {
          if (pack.id === p.id) {
            p.invalid = pack.invalid;
            if (p.invalid && p.invalid.invalid) {
              p.p_checked = false;
            }
            return true;
          }
        });
      });
    }
  }, {
    key: 'removePacks',
    value: function removePacks(packs) {
      var guids = packs.map(function (pack) {
        return pack.g_uid;
      });
      this.packs = this.packs.filter(function (pack) {
        var guid = pack.guid();
        var index = guids.indexOf(guid);
        if (~index) {
          pack = null;
          deleteInstance(guid);
          return false;
        } else {
          return true;
        }
      });
      this.data.packs = this.data.packs.filter(function (pack) {
        return !~guids.indexOf(pack.g_uid);
      });
    }
  }, {
    key: 'emptyPreview',
    value: function emptyPreview() {
      this.data.addiblePacks = [];
      this.data.labels = [];
      this.data.giftPacks = [];
      this.setLabelModel();
      this.setAddibleModel();
      this.resetInvalidPacks();
    }
  }, {
    key: 'resetInvalidPacks',
    value: function resetInvalidPacks() {
      this.data.packs.forEach(function (pack) {
        var invalid = invalidPacksMap[pack.id];
        if (invalid) {
          pack.invalid = invalid;
        }
      });
    }
  }, {
    key: 'getCheckedPacksIds',
    value: function getCheckedPacksIds(editMode) {
      var checkedPacks = this.getCheckedPacks(editMode);
      var ids = checkedPacks.map(function (pack) {
        return pack.id;
      });
      return ids;
    }
  }, {
    key: 'getCheckedPacks',
    value: function getCheckedPacks(editMode) {
      return this.data.packs.filter(function (pack) {
        var checked = editMode ? pack.p_editModeChecked : pack.p_checked;
        if (checked) {
          return pack;
        }
      });
    }
  }, {
    key: 'groupCheckboxTap',
    value: function groupCheckboxTap() {
      var _this8 = this;

      var t = this.data;
      if (this.data.editMode || this.data.disableCheck) {
        return;
      }
      t.allChecked = !t.allChecked;
      this.togglePacksSelect(t.allChecked);
      var beforePreviewPacksLength = this.getCheckedPacks().length;
      this.refreshPreview().then(function (result) {
        if (!result) {
          return;
        }
        // after all packs are selected,
        // get benefit packs status(invalid or not) from preview,
        // if benefit packs are valid, 
        // select it, then refresh preview
        if (t.allChecked) {
          _this8.togglePacksSelect(t.allChecked);
          var afterPreviewPacksLength = _this8.getCheckedPacks().length;
          if (afterPreviewPacksLength > beforePreviewPacksLength) {
            _this8.refreshPreview();
          }
        }
      });
      this.emit('select-change');
    }
  }, {
    key: 'togglePacksSelect',
    value: function togglePacksSelect(val) {
      if (this.data.editMode) {
        return;
      }
      this.data.packs.forEach(function (pack) {
        if (pack.invalid && pack.invalid.invalid) {
          pack.p_checked = false;
          return;
        }
        pack.p_checked = val;
      });
    }
  }, {
    key: 'editMode',
    value: function editMode(val) {
      this.data.editMode = val;
      this.packs.forEach(function (pack) {
        pack.editMode(val);
      });
      this.labels.forEach(function (label) {
        label.editMode(val);
      });
      this.addibles.forEach(function (addible) {
        addible.editMode(val);
      });
      if (!val) {
        this.setAllChecked();
        this.refreshPreview();
      }
    }
  }]);
  return Group;
}(_events.EventEmitter);

exports.default = Group;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@beastshop/cart/lib/model/base/group.js
// module id = 675
// module chunks = 0